import { mergeTranslations } from "ra-core";

import { dutchCrmCatalog } from "./crm";
import { dutchCrmMessages } from "./palmtree";
import { dutchRaMessages } from "./ra";
import { nlSearchMessages } from "./search";
import { dutchSupabaseMessages } from "./supabase";

/**
 * Active Dutch catalog.
 * To add a language: copy this folder to src/i18n/<locale>, translate the
 * strings (same keys), and register the merge in the i18nProvider.
 * PalmTree overrides in palmtree.ts win over the generic CRM copy.
 */
export const nlMessages = mergeTranslations(
  dutchRaMessages,
  dutchSupabaseMessages,
  dutchCrmCatalog,
  dutchCrmMessages,
  nlSearchMessages,
);
